import { useState, useEffect } from "react";
import { onMessage } from "firebase/messaging";
import PopupMessage from "./PopupMessage"; // 👈 استدعاء الكومبوننت بتاعك
import { messaging } from "../../firebase";

const ForegroundListener = () => {
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    // الدالة دي بتشتغل تلقائي لما ييجي إشعار والموقع مفتوح
    const unsubscribe = onMessage(messaging, (payload) => {
      
      // فاكر لما خلينا الباك إند يبعت data بدل notification؟ هنقرأ منها هنا
      const title = payload.data?.title;
      const body = payload.data?.body;

      // تحديث الـ State عشان نعرض الإشعار
      setNotification({
        title: title,
        body: body,
      });
    });

    // تنظيف الـ Listener لما الكومبوننت يقفل
    return () => unsubscribe();
  }, []);

  // لو مفيش إشعار جاي، منرندرش حاجة
  if (!notification) return null;

  return (
    <div style={{ position: "fixed", top: "20px", right: "20px", zIndex: 9999 }}>
      <PopupMessage
        type="info" // استخدمنا info عشان يكون لون مناسب للإشعارات
        message={`🔔 ${notification.title} - ${notification.body}`}
        onClose={() => setNotification(null)} // لما الإشعار يختفي، نفضي الـ state
      />
    </div>
  );
};

export default ForegroundListener;